import { http } from './request';
import { NOTIFICATION_URLS } from './urls';

export type NotificationTagType = 'PURPLE' | 'RED' | 'BLUE' | 'GREEN';

export interface SystemNotificationTag {
  text: string;
  type: NotificationTagType;
}

export interface SystemNotificationItem {
  id: number;
  listTitle: string;
  title?: string;
  detailTitle: string;
  detailContent?: string;
  content?: string;
  tagText: string;
  tagType: NotificationTagType;
  tags?: SystemNotificationTag[];
  read: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface SystemNotificationListResponse {
  list: SystemNotificationItem[];
  unreadCount: number;
}

export function fetchNotifications() {
  return http.get<SystemNotificationListResponse>(NOTIFICATION_URLS.list);
}

export function markNotificationRead(id: number | string) {
  return http.post<SystemNotificationItem>(NOTIFICATION_URLS.read(id));
}

export function markAllNotificationsRead() {
  return http.post<{ readCount: number; unreadCount: number }>(NOTIFICATION_URLS.readAll);
}
